import { render } from "./InvoiceDiv.vue?vue&type=template&id=15570781&scoped=true"
import script from "./InvoiceDiv.vue?vue&type=script&lang=js"
export * from "./InvoiceDiv.vue?vue&type=script&lang=js"

import "./InvoiceDiv.vue?vue&type=style&index=0&id=15570781&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15570781"]])

export default __exports__